export enum Namespaces {
  Monitoring = 'monitoring',
  SourceCode = 'source_code',
  System = 'sys',
}
